import axios from 'axios';

import type { IErrorResponse } from '../api/types/response';

type HttpError = {
    error_type: 'http';
    error_message: string | undefined;
    http_status: number | undefined;
    response_message: string | undefined;
    error_code: string | undefined;
};

type RuntimeError = {
    error_type: 'runtime';
    error_message: string | undefined;
};

export type ExtractedApiError = HttpError | RuntimeError;

type AxiosCauseError = {
    isAxiosError: true;
    code?: string;
    response?: IErrorResponse['response'];
};

// AxiosError sets isAxiosError = true; ApiMethods wraps it as { cause: axiosError }
const hasAxiosCause = (error: unknown): error is { message: string; cause: AxiosCauseError } => {
    const cause = (error as Record<string, unknown>)?.cause;

    return typeof cause === 'object' && cause !== null && axios.isAxiosError(cause);
};

export const extractApiError = (error: unknown): ExtractedApiError => {
    if (hasAxiosCause(error)) {
        const { cause } = error;

        return {
            error_type: 'http',
            error_message: error.message,
            http_status: cause.response?.status,
            response_message: cause.response?.data.error ?? cause.response?.data.message,
            error_code: cause.code,
        };
    }

    return { error_type: 'runtime', error_message: (error as Error)?.message };
};
